import React, { useContext } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { ImFileText, ImStatsDots } from "react-icons/im";
import { BiAddToQueue, BiUserCircle } from "react-icons/bi";
import { GiExitDoor } from "react-icons/gi";
import { VscNewFile } from "react-icons/vsc";
import { BsSliders } from "react-icons/bs";

import Cabecalho from "../../components/Cabecalho/Cabecalho";
import { Context } from "../../context/AuthContext";
import { BoletimContext } from "../../context/BoletimContext";
import { hasPermission } from "../../Utils/permissions";
import "./styles/dashboard-modern.css";
import { isBoletimAdministrator } from '../../Utils/permissions';

const Dashboard = () => {
  const { setAuthenticated, setOfflineMode } = useContext(Context);
  const { boletim, setBoletim, flushLocalDraft, discardCurrentDraft, syncStatus } = useContext(BoletimContext);
  const navigate = useNavigate();
  const handleSair = async () => {
    try {
      await flushLocalDraft();
    } catch (error) {
      alert(error.message || "Sincronize ou descarte explicitamente o rascunho antes de sair.");
      return;
    }
    ["x-access-token", "x-user-id", "x-user-mat-id", "x-user-tipo", "x-user-municipio", "x-role-key", "x-permissions"].forEach((key) =>
      localStorage.removeItem(key)
    );
    setOfflineMode(false);
    setAuthenticated(false);
    navigate("/");
  };

  const handleClickNovoBoletim = async () => {
    const hasDraft = syncStatus.state !== "synced" && (
      boletim.numero || boletim.data || boletim.natureza ||
      boletim.historicohtml || boletim.envolvidos?.length ||
      boletim.materiaisApreendidos?.length || boletim.efetivo?.length
    );
    if (hasDraft && !window.confirm("Há um boletim em andamento. Deseja descartar esse rascunho e iniciar outro?")) {
      navigate("/boletim/header");
      return;
    }

    const newBoletim = {
      municipio: localStorage.getItem("x-user-municipio") || "Balsas",
      numero: "",
      natureza: "",
      naturezaId: "",
      naturezaIds: [],
      data: "",
      horario: "",
      envolvidos: [],
      materiaisApreendidos: [],
      efetivo: [],
      historicohtml: "",
    };
    if (hasDraft) await discardCurrentDraft();
    setBoletim(newBoletim);
    navigate("/boletim/header");
  };

  const menuItems = [
    ...(isBoletimAdministrator() && hasPermission('boletins.admin.view') ? [{ title: 'Gerenciar Boletins', description: 'Administração, duplicidades, excluídos e auditoria', icon: <ImFileText size={30} />, action: () => navigate('/administrador/boletins') }] : []),
    ...(hasPermission("boletins.create") ? [{
      title: "Registrar ocorrência",
      description: "Iniciar ou continuar um boletim",
      icon: <VscNewFile size={32} />,
      action: handleClickNovoBoletim,
      highlight: true,
    }] : []),
    ...(hasPermission("boletins.view.own") || hasPermission("boletins.view.all") ? [{
      title: "Pesquisar boletins",
      description: "Consultar seus registros por data, número ou conteúdo",
      icon: <ImFileText size={30} />,
      action: () => navigate("/dashboard/boletim"),
    }] : []),
    ...(hasPermission("statistics.view") ? [
      {
        title: "Estatísticas",
        description: "Visão geral, naturezas, comparação e relatórios.",
        icon: <ImStatsDots size={30} />,
        action: () => navigate("/dashboard/estatisticas"),
      },
    ] : []),
    ...(hasPermission("users.view") ? [
      {
        title: "Gerenciar usuários",
        description: "Administração de acessos",
        icon: <BiAddToQueue size={30} />,
        action: () => navigate("/administrador/usuarios"),
      },
    ] : []),
    ...(hasPermission("naturezas.manage") || hasPermission("localidades.manage") ? [
      {
        title: "Opções do Boletim",
        description: "Configurar naturezas, bairros e localidades.",
        icon: <BsSliders size={30} />,
        action: () => navigate("/administrador/opcoes-boletim"),
      },
    ] : []),
    ...(hasPermission("dashboard.view") ? [
      {
        title: "Meu perfil",
        description: "Consultar seus dados de acesso",
        icon: <BiUserCircle size={30} />,
        action: () => navigate("/perfil"),
      },
    ] : []),
  ];

  return (
    <>
      <Cabecalho />
      <main className="dashboard-modern">
        <Container>
          <div className="dashboard-heading">
            <div>
              <p className="dashboard-eyebrow">Painel de controle</p>
              <h2>Boletim Eletrônico</h2>
              <p className="dashboard-intro">Acesse os serviços disponíveis para sua conta.</p>
            </div>
          </div>

          <Row className="g-3">
            {menuItems.map((item) => (
              <Col key={item.title} xs={12} sm={6} lg={4}>
                <button
                  type="button"
                  className={`dashboard-tile ${item.highlight ? "highlight" : ""}`}
                  onClick={item.action}
                >
                  <span className="tile-icon">{item.icon}</span>
                  <span className="tile-copy">
                    <span className="tile-title">{item.title}</span>
                    <span className="tile-description">{item.description}</span>
                  </span>
                </button>
              </Col>
            ))}
          </Row>

          <div className="dashboard-footer">
            <span>4º Batalhão de Polícia Militar · Maranhão</span>
            <Button variant="outline-danger" className="logout-btn" onClick={handleSair}>
              <GiExitDoor className="me-2" /> Sair
            </Button>
          </div>
        </Container>
      </main>
    </>
  );
};

export default Dashboard;
